import React, {Component} from 'react'
import { observer } from 'mobx-react'
import liqpayGeneratorStore from "../../store/LiqpayGeneratorStore";
import {LQ_STEPS, LQ_STEPS_TITLE} from "../../config/constants";

@observer
class LiqpayModal extends Component {
    render() {
        return (
            <>
            { liqpayGeneratorStore.showCouponInfo &&
            <div className='liqpay-modal' onClick={() => liqpayGeneratorStore.hideCouponModal()}>
                { liqpayGeneratorStore.couponData == null &&
                    <div className="liqpay-modal__dialog">
                        <div style={{textAlign: "center"}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#ff2200"
                                 className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path
                                    d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
                                <path
                                    d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
                            </svg>
                        </div>
                        Купон <b>{liqpayGeneratorStore.couponCode}</b> не існує, закінчився строк його дії, або він вже
                        був використаний
                    </div>
                }
                { liqpayGeneratorStore.couponData != null &&
                    <div className="liqpay-modal__dialog">
                        <div style={{textAlign: "center"}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#00c851"
                                 className="bi bi-check-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                <path
                                    d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
                            </svg>
                        </div>
                        <table>
                            <tr>
                                <td>Код купона</td>
                                <td><b>{liqpayGeneratorStore.couponData.code}</b></td>
                            </tr>
                            <tr>
                                <td>Назва</td>
                                <td>{liqpayGeneratorStore.couponData.name}</td>
                            </tr>
                            <tr>
                                <td>Телефон</td>
                                <td>{liqpayGeneratorStore.couponData.phone == null ||  liqpayGeneratorStore.couponData.phone === '' ? 'немає' : liqpayGeneratorStore.couponData.phone}</td>
                            </tr>
                            <tr>
                                <td>Знижка</td>
                                <td>{liqpayGeneratorStore.couponData.discount}{liqpayGeneratorStore.couponData.type === 'P' ? '%' : '₴'}</td>
                            </tr>
                            <tr>
                                <td>Термін дії</td>
                                <td>з {liqpayGeneratorStore.couponData.date_start} до {liqpayGeneratorStore.couponData.date_end}</td>
                            </tr>
                            <tr>
                                <td>Можливість використань</td>
                                {liqpayGeneratorStore.couponData.uses_total === "0" &&
                                <td>необмежено</td>
                                }
                                {liqpayGeneratorStore.couponData.uses_total === "1" &&
                                <td>одноразовий</td>
                                }
                                {parseInt(liqpayGeneratorStore.couponData.uses_total) > 1 &&
                                <td>{liqpayGeneratorStore.couponData.uses_total}</td>
                                }
                            </tr>
                        </table>
                    </div>
                }
            </div>
            }
            </>
        )
    }
}

export default LiqpayModal
